// //blog/[slug].js
// import Head from "next/head";
// import { useRouter } from "next/router";
// import LoadingSpinner from "../../components/common/LoadingSpinner";
// import BlogDetails from "../../components/blog-details";
// import CommentsSection from "../../components/comments-section";
// import PostComments from "../../components/post-comments";
// import RecentBlogs from "../../components/recent-blogs";
// import CommonBanner from "../../components/common/CommonBanner";
// import Header from "../../components/common/Header";
// import Footer from "../../components/footer";
// import { serverSideTranslations } from "next-i18next/serverSideTranslations";
// import {
//   fetchBlogData,
//   fetchBlogDetails,
// } from "../../components/http/commonApi";
// import HreflangLinks from "../../components/common/HrefLinkTags";
// import CommonBanner2 from "../../components/common/CommonBanner2";
// import { useTranslation } from "next-i18next";
// //
// export default function BlogInner({ blogDetails, locale, recentBlogs }) {
//   const { t } = useTranslation("blogs");
//   const router = useRouter();

//   if (router.isFallback) {
//     return <LoadingSpinner message="Loading blog details..." />;
//   }
//   return (
//     <>
//       {/* <HreflangLinks
//         enPath={`/blog/${blogDetails?.slug}`}
//         arPath={`/blog/${blogDetails?.slug}`} // same slug, just under /ar
//       /> */}

//       <HreflangLinks
//         enPath={`/blog/${blogDetails?.slug}`}
//         arPath={blogDetails?.hasArabic ? `/ar/blog/${blogDetails.slug}` : null}
//       />

//       <Head>
//         <title>
//           {blogDetails?.metaTitle ||
//             "Prism Digital | Top Digital Marketing Agency in UAE"}
//         </title>
//         <meta
//           name="description"
//           content={
//             blogDetails?.metaDescription ||
//             "A leading digital marketing agency in UAE - Prism Digital, offering SEO, PPC, social media, and web design services to grow your brand online. Book us today!"
//           }
//         />
//         {locale === "ar" ? (
//           <link
//             rel="canonical"
//             href={`https://www.prism-me.com/${locale}/blog/${blogDetails?.slug}`}
//           />
//         ) : (
//           <link
//             rel="canonical"
//             href={`https://www.prism-me.com/blog/${blogDetails?.slug}`}
//           />
//         )}
//       </Head>
//       <Header />
//       <main className="box-border w-full bg-background-color-primary">
//         {/* <CommonBanner name={blogDetails?.title} /> */}
//         <CommonBanner2
//           name={blogDetails?.title}
//           breadcrumbProps={{
//             labelMap: {
//               home: locale === "ar" ? "الرئيسية" : "Home",
//               blog: locale === "ar" ? "المدونة" : "Blog",
//             },
//             dynamicLabel: blogDetails?.title, // the blog title (last crumb)
//             separator: locale === "ar" ? "‹" : ">",
//           }}
//         />
//         <BlogDetails singleBlog={blogDetails} />
//         {blogDetails?.userComments?.length > 0 && (
//           <CommentsSection comments={blogDetails?.userComments} />
//         )}
//         <PostComments id={blogDetails?._id} />
//         {recentBlogs?.length > 0 && <RecentBlogs recentBlogs={recentBlogs} />}
//       </main>
//       <Footer />
//     </>
//   );
// }

// export async function getServerSideProps({ params, locale, res }) {
//   try {
//     const { data: blogDetails } = await fetchBlogDetails(params.slug, locale);

//     if (!blogDetails) {
//       return {
//         redirect: {
//           destination: locale === "ar" ? "/ar/blogs" : "/blogs",
//           permanent: false,
//         },
//       };
//     }

//     const available = blogDetails?.availableLangs || {};
//     const isAr = locale === "ar";

//     // ✅ Redirect rules
//     if (isAr && available.ar === false) {
//       return {
//         redirect: { destination: "/ar/blog", permanent: false },
//       };
//     }
//     if (!isAr && available.en === false) {
//       return {
//         redirect: { destination: "/blog", permanent: false },
//       };
//     }

//     const page = 1;
//     const limit = 4;

//     const { data: allBlogs = [] } = await fetchBlogData({
//       page,
//       limit,
//       lang: locale,
//     });
//     const recentBlogs = allBlogs?.blogs;
//     // const recentBlogs = allBlogs?.blogs?.filter(
//     //   (item) => item?.slug !== params.slug
//     // );

//     // ✅ Set cache headers
//     res.setHeader(
//       "Cache-Control",
//       "public, s-maxage=60, stale-while-revalidate=300",
//     );

//     return {
//       props: {
//         blogDetails,
//         recentBlogs,
//         locale,
//         ...(await serverSideTranslations(locale, [
//           "header",
//           "footer",
//           "blogs",
//           "common",
//         ])),
//       },
//     };
//   } catch (error) {
//     console.error("Error in getServerSideProps (blogs):", error);
//     return {
//       // notFound: true,
//       redirect: {
//         destination: `/${locale}/blog`, // or '/'
//         permanent: false,
//       },
//     };
//   }
// }

//blog/[slug].js
import Head from "next/head";
import { useRouter } from "next/router";
import LoadingSpinner from "../../components/common/LoadingSpinner";
import BlogDetails from "../../components/blog-details";
import CommentsSection from "../../components/comments-section";
import PostComments from "../../components/post-comments";
import RecentBlogs from "../../components/recent-blogs";
import Header from "../../components/common/Header";
import Footer from "../../components/footer";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import {
  fetchBlogData,
  fetchBlogDetails,
} from "../../components/http/commonApi";
import HreflangLinks from "../../components/common/HrefLinkTags";
import CommonBanner2 from "../../components/common/CommonBanner2";
import { useTranslation } from "next-i18next";

/**
 * Fallback check, only used when the API response has no `availableLangs`.
 * `availableLangs` is the source of truth; `hasArabic` is unreliable
 * (it can be false while availableLangs.ar is true), so it is only
 * consulted when availableLangs is missing.
 * Any error => false (omit the tag rather than point at a possible 404).
 */
async function twinExists(slug, otherLocale) {
  try {
    const { data } = await fetchBlogDetails(slug, otherLocale);
    if (!data) return false;

    const flag = data?.availableLangs?.[otherLocale];
    if (flag === false) return false;
    if (flag === true) return true;

    if (otherLocale === "ar" && data?.hasArabic === false) return false;

    return true;
  } catch (e) {
    return false;
  }
}

export default function BlogInner({
  blogDetails,
  locale,
  recentBlogs,
  enExists = true,
  arExists = true,
}) {
  const { t } = useTranslation("blogs");
  const router = useRouter();

  if (router.isFallback) {
    return <LoadingSpinner message="Loading blog details..." />;
  }
  return (
    <>
      {/* The page itself is always listed. The other language is listed
          only if that exact address loads (200). x-default => English. */}
      <HreflangLinks
        enPath={enExists ? `/blog/${blogDetails?.slug}` : null}
        arPath={arExists ? `/ar/blog/${blogDetails?.slug}` : null}
      />

      <Head>
        <title>
          {blogDetails?.metaTitle ||
            "Prism Digital | Top Digital Marketing Agency in UAE"}
        </title>
        <meta
          name="description"
          content={
            blogDetails?.metaDescription ||
            "A leading digital marketing agency in UAE - Prism Digital, offering SEO, PPC, social media, and web design services to grow your brand online. Book us today!"
          }
        />
        {locale === "ar" ? (
          <link
            rel="canonical"
            href={`https://www.prism-me.com/${locale}/blog/${blogDetails?.slug}`}
          />
        ) : (
          <link
            rel="canonical"
            href={`https://www.prism-me.com/blog/${blogDetails?.slug}`}
          />
        )}
      </Head>
      <Header />
      <main className="box-border w-full bg-background-color-primary">
        <CommonBanner2
          name={blogDetails?.title}
          breadcrumbProps={{
            labelMap: {
              home: locale === "ar" ? "الرئيسية" : "Home",
              blog: locale === "ar" ? "المدونة" : "Blog",
            },
            dynamicLabel: blogDetails?.title, // the blog title (last crumb)
            separator: locale === "ar" ? "‹" : ">",
          }}
        />
        <BlogDetails singleBlog={blogDetails} />
        {blogDetails?.userComments?.length > 0 && (
          <CommentsSection comments={blogDetails?.userComments} />
        )}
        <PostComments id={blogDetails?._id} />
        {recentBlogs?.length > 0 && <RecentBlogs recentBlogs={recentBlogs} />}
      </main>
      <Footer />
    </>
  );
}

export async function getServerSideProps({ params, locale, res }) {
  try {
    const { data: blogDetails } = await fetchBlogDetails(params.slug, locale);

    // Missing post => real 404 (never a redirect to the blog index)
    if (!blogDetails) {
      return { notFound: true };
    }

    const available = blogDetails?.availableLangs || {};
    const isAr = locale === "ar";

    // Post exists but not in the requested language => keep the visitor on
    // the same post in the language that exists (temporary redirect), so the
    // language switcher never lands on a 404 or the blog index.
    if (isAr && available.ar === false) {
      if (available.en === false) return { notFound: true };
      return {
        redirect: { destination: `/blog/${params.slug}`, permanent: false },
      };
    }
    if (!isAr && available.en === false) {
      if (available.ar === false) return { notFound: true };
      return {
        redirect: { destination: `/ar/blog/${params.slug}`, permanent: false },
      };
    }

    // Does the other language's twin page exist?
    // availableLangs from the current response is the source of truth
    // (same field the redirects above use). Only call the API again
    // if the flag is missing.
    const otherLocale = isAr ? "en" : "ar";
    const otherFlag = available[otherLocale];
    const otherExists =
      typeof otherFlag === "boolean"
        ? otherFlag
        : await twinExists(params.slug, otherLocale);

    const page = 1;
    const limit = 4;

    const { data: allBlogs = [] } = await fetchBlogData({
      page,
      limit,
      lang: locale,
    });
    const recentBlogs = allBlogs?.blogs;

    // ✅ Set cache headers
    res.setHeader(
      "Cache-Control",
      "public, s-maxage=60, stale-while-revalidate=300",
    );

    return {
      props: {
        blogDetails,
        recentBlogs,
        locale,
        enExists: isAr ? otherExists : true,
        arExists: isAr ? true : otherExists,
        ...(await serverSideTranslations(locale, [
          "header",
          "footer",
          "blogs",
          "common",
        ])),
      },
    };
  } catch (error) {
    const status = error?.response?.status;

    // API says the post doesn't exist => real 404
    if (status === 404 || status === 400) {
      return { notFound: true };
    }

    // Anything else is a genuine server/API failure: surface it as a 500
    // rather than redirecting to the blog index.
    console.error("Error in getServerSideProps (blogs):", error);
    throw error;
  }
}
